var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.showLoading ? _c('div', [_c('Loading')], 1) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v("手機驗證")]), _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" 簡訊驗證碼已發送至"), _c('b', [_vm._v(_vm._s(_vm.mobile))]), _vm._v("，"), _c('br'), _vm._v(" 驗證碼將於 "), _c('b', [_vm._v(_vm._s(_vm.timeout.minute))]), _vm._v(" 分 "), _c('b', [_vm._v(_vm._s(_vm.timeout.second))]), _vm._v(" 秒後失效 ")]), _c('div', {
    staticClass: "code-input"
  }, [_c('CodeInput', {
    staticClass: "google-sans-code",
    class: {
      invalid: _vm.smsCodeFail
    },
    attrs: {
      "loading": false,
      "fields": 6,
      "fieldHeight": 80,
      "disabled": _vm.counter === 0
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm.smsCodeFail ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 驗證碼有誤，請再次確認 ")]) : _vm._e()], 1), _c('div', {
    staticClass: "page__bottom"
  }, [_vm._v(" 沒收到嗎？"), _c('span', {
    on: {
      "click": _vm.handleResend
    }
  }, [_vm._v("重新發送驗證碼")])])]), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.counter === 0
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" 送出 ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }